import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-150 flex-col flex items-center justify-center gap-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Loading payment methods...", -1)
const _hoisted_3 = {
  key: 1,
  class: "min-h-150 flex flex-col"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2 flex-grow items-center justify-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "px-4 py-2.5 text-lg border-0 border-b border-solid border-gray-300" }, " Choose payment method to make payment ", -1)
const _hoisted_7 = { class: "flex flex-col gap-2 max-h-300 px-4 py-4 overflow-auto scrollbar" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex ml-4 flex-col" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "uppercase" }
const _hoisted_13 = { class: "text-xs" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-dark-blue-400 bg-opacity-25 rounded-md text-xs ml-8 px-2 py-1" }, " Default ", -1)
const _hoisted_15 = {
  key: 2,
  class: "relative"
}
const _hoisted_16 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col gap-2 items-center justify-center bg-white bg-opacity-75 z-1000"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Making payment", -1)
const _hoisted_18 = { class: "px-4 py-2.5 text-lg border-0 border-b border-solid border-gray-300 flex gap-3" }
const _hoisted_19 = { class: "flex items-center pr-2 gap-2" }
const _hoisted_20 = { class: "flex items-center group cursor-pointer bg-dark-blue-400 bg-opacity-10 p-2 rounded-md transition" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "flex ml-4 flex-col" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "uppercase" }
const _hoisted_25 = { class: "text-xs" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "bg-dark-blue-400 bg-opacity-25 rounded-md text-xs ml-8 px-2 py-1" }, " Default ", -1)
const _hoisted_27 = { class: "flex items-center gap-5 justify-center" }

import {
	Dialog,
	BorderedButton,
	SvgIcon,
	UiInput,
	useForm,
	UiForm,
	UiButton,
	UiLoader
} from '@/ui-kit';
import { httpService, Nullable } from '@/utils';
import { useToggle } from '@vueuse/shared';
import { computed, ref } from 'vue';
import { StripePaymentMethod } from '../types';
import { usePaymentMethodsState } from '../use-payment-methods.state';
import { required, minValue } from '@vuelidate/validators';
import { useToast } from 'vue-toastification';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'MakePaymentDialog',
  setup(__props, { expose }) {

const minimumPaymentAmount = computed(() => {
	let amount = parseFloat(balanceRaw.value);

	if (Number.isNaN(amount) || amount > 0) {
		amount = 20;
	} else if (amount < 0) {
		amount = amount * -1;
	}

	return amount;
});

const { success } = useToast();
const state = usePaymentMethodsState();
const { balanceRaw } = useCompanyProfile();
const [isOpened, setIsOpened] = useToggle();

const cardImageSrc = function (brand: string) {
	const cardTypes = [
		'visa',
		'mastercard',
		'dinners-club',
		'maestro',
		'jcb',
		'american-express',
		'discover'
	];
	const cardType = `${
		brand
			? cardTypes.find((type) => brand === type) ||
			  'default'
			: 'default'
	}.png`;
	return `/cards/${cardType}`;
};

const selectedPaymentMethod =
	ref<Nullable<StripePaymentMethod>>(null);

const { formData, loading, resetForm, onSubmit } = useForm(
	{ amount: 20 },
	{
		amount: {
			required,
			minValue: minValue(minimumPaymentAmount.value)
		}
	}
);

function openDialog() {
	if (state.isLoading) {
		state.loadPaymentMethods();
	}
	selectedPaymentMethod.value = null;

	resetForm({
		amount: minimumPaymentAmount.value
	});
	setIsOpened(true);
}

const makePayment = onSubmit(async (data) => {
	await httpService.post('company/billing/payments', {
		payment_method:
			selectedPaymentMethod.value!.stripe_payment_id,
		amount: data.amount
	});
	success('Added funds to your account.');
	setIsOpened(false);
});

expose({
	openDialog
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _unref(setIsOpened),
    preventDefaultClose: _unref(loading)
  }, {
    default: _withCtx(() => [
      (_unref(state).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(UiLoader))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_unref(state).paymentMethods.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(" You have no payment methods added. "),
                  _createVNode(_component_RouterLink, { to: {
						name: 'BillingPaymentMethods',
						query: {
							openDialog: '1'
						}
					} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UiButton), {
                        class: "!text-sm !h-8 !min-w-20 w-44 !px-0",
                        theme: "primary-outlined"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(SvgIcon), {
                            class: "h-4 w-4 mr-2",
                            name: "plus"
                          }),
                          _createTextVNode("Add payment method ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (!selectedPaymentMethod.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).paymentMethods, (method) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "flex items-center group cursor-pointer hover:bg-dark-blue-400 hover:bg-opacity-10 p-2 rounded-md transition",
                          key: method.stripe_payment_id,
                          onClick: ($event: any) => (
							selectedPaymentMethod.value = method
						)
                        }, [
                          _createElementVNode("img", {
                            class: "h-9",
                            src: 
								cardImageSrc(method.brand)
							
                          }, null, 8, _hoisted_9),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(method.brand), 1),
                              _createTextVNode(" **** **** **** " + _toDisplayString(method.last4), 1)
                            ]),
                            _createElementVNode("div", _hoisted_13, " Expires " + _toDisplayString(method.exp_month) + "/" + _toDisplayString(method.exp_year), 1)
                          ]),
                          (method.is_primary)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                "show-after": 500,
                                "hide-after": 0,
                                content: "Future payments will use this payment method."
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_8))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_unref(loading))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_unref(UiLoader))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(BorderedButton), {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (
							selectedPaymentMethod.value = null
						))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(SvgIcon), {
                              name: "BackArrowIcon",
                              class: "h-3 w-3"
                            }),
                            _createTextVNode(" Back ")
                          ])
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Enter amount to make payment ")
                    ]),
                    _createVNode(_unref(UiForm), {
                      onSubmit: _unref(makePayment),
                      class: "px-4 py-4 flex flex-col gap-2 relative"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("img", {
                            class: "h-9",
                            src: 
								cardImageSrc(
									selectedPaymentMethod.value.brand
								)
							
                          }, null, 8, _hoisted_21),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(selectedPaymentMethod.value.brand), 1),
                              _createTextVNode(" **** **** **** " + _toDisplayString(selectedPaymentMethod.value.last4), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, " Expires " + _toDisplayString(selectedPaymentMethod.value.exp_month) + "/" + _toDisplayString(selectedPaymentMethod.value.exp_year), 1)
                          ]),
                          (
								selectedPaymentMethod.value.is_primary
							)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                "show-after": 500,
                                "hide-after": 0,
                                content: "Future payments will use this payment method."
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_unref(UiInput), {
                          modelValue: _unref(formData).amount,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).amount) = $event)),
                          name: "amount",
                          type: "number",
                          label: "Amount",
                          min: _unref(minimumPaymentAmount),
                          step: "0.01",
                          disabled: _unref(loading)
                        }, null, 8, ["modelValue", "min", "disabled"]),
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_unref(UiButton), {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setIsOpened)(false))),
                            theme: "primary-outlined",
                            type: "button",
                            class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                            disabled: _unref(loading)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cancel ")
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_unref(UiButton), {
                            class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                            loading: _unref(loading)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Make Payment ")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["onSubmit"])
                  ]))
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue", "preventDefaultClose"]))
}
}

})